module.exports = __webpack_public_path__ + "img/retrolight.8ed584c0.webp";